import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Button,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Collapse,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import moment from "moment";
import FormikSelectInput from "@/components/forms/FormikSelectInput";
import FormikDatePicker from "@/components/forms/FormikDatePicker";
import { CardWithActions, StyledButton } from "@/components";
import { TableWrapper, StyledTable } from "./StyledTable";
import {
  useGetAdminAttendanceTrackerQuery,
  useLazyGetDownloadTrackerReportExcelQuery,
} from "@/api/services/attendanceManagement/adminAttendanceReport/AdminAttendanceReport";
import FormikMonthYearPicker from "@/components/forms/FormikMonthYearPicker";
import { useFetchSettingsRowsQuery } from "@/api/services/Settings/business/Business";
import { useFetchSettingsQuery } from "@/api/services/Settings/menu/Menu";
import { useFetchEmployeesByParentOrgQuery } from "@/api/services/employeeList/EmployeeList";
import SubmitButtonWithLoader from "@/components/forms/SubmitButtonWithLoader";
import { DownloadIcon } from "@/icons";
import * as XLSX from "xlsx";

const AttendanceTracker = () => {
  const [selectedMonth, setSelectedMonth] = useState(
    moment().format("MM-YYYY"),
  );
  const [rows, setRows] = useState([]);
  const [expandedDepartments, setExpandedDepartments] = useState({});
  const [loading, setLoading] = useState(false);
  const today = new Date();

  const formatDate = (date) => date.toLocaleDateString("en-CA"); // YYYY-MM-DD

  const [startDate, setStartDate] = useState(
    formatDate(new Date(today.getFullYear(), today.getMonth(), 1)),
  );

  const [endDate, setEndDate] = useState(
    formatDate(new Date(today.getFullYear(), today.getMonth() + 1, 0)),
  );
  const [employeeId, setEmployee] = useState("");
  const [workLocation, setWorkLocation] = useState("");
  const [department, setDepartment] = useState("");
  const [swipe, setSwipe] = useState("");

  const {
    data: rowDetails = {},
    refetch,
    isLoading,
    isFetching,
    isUninitialized,
  } = useGetAdminAttendanceTrackerQuery({
    startDate: startDate,
    endDate: endDate,
    empId: employeeId,
    deparment: department,
    swipeMethod: swipe,
    workLocation: workLocation,
  });
  const [trackerDownload, { isLoading: isDownloading }] =
    useLazyGetDownloadTrackerReportExcelQuery();
  const { data: workLocationOptions = [] } = useFetchSettingsQuery({
    referenceName: "Work Location",
  });
  const { data: departmentOptions = [] } = useFetchSettingsQuery({
    referenceName: "Department",
  });
  const { data: swipeMethodOptions = [] } = useFetchSettingsQuery({
    referenceName: "Swipe Method",
  });
  const { data: fetchAllEmployees } = useFetchEmployeesByParentOrgQuery();

  console.log(workLocationOptions, "work");

  const refetchData = async () => {
    setLoading(true);
    try {
      await refetch();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (!isUninitialized) {
  //     refetchData();
  //   }
  // }, [selectedMonth, isUninitialized]);

  const handleSubmit = async () => {
    const response = await trackerDownload({
      startDate: startDate,
      endDate: endDate,
      empId: employeeId,
      deparment: department,
      swipeMethod: swipe,
      workLocation: workLocation,
    }).unwrap();
    // if (!sampleData || !(sampleData instanceof Blob)) {
    //   return;
    // }
    const url = URL.createObjectURL(response);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Attendance Tracker Report.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const loadings = isLoading || loading || isFetching;

  const formatToYMD = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    if (!rowDetails?.data) return;

    const structured = Object.entries(rowDetails.data).map(
      ([deptName, deptData]) => ({
        department: deptName,
        ...deptData,
      }),
    );

    setRows(structured);
  }, [rowDetails]);

  const prepareExcelData = (apiData) => {
    const rows = [];

    Object.entries(apiData).forEach(([departmentName, deptData]) => {
      deptData?.members?.forEach((emp) => {
        // ✅ FIX HERE
        const dates = emp?.empReport?.dates || {};

        // If employee has NO date data
        if (Object.keys(dates).length === 0) {
          rows.push({
            Department: departmentName,
            "Employee ID": emp.empId,
            "Employee Name": emp.empName,
            Date: "-",

            "In Punch Count": "-",
            "Out Punch Count": "-",
            "Total Hours": "-",
            "Productive Hours": "-",
            "Break Hours": "-",

            "Present Days": emp.empPresentDayCount,
            "Avg Login Hours": emp.empAvgLoginHourse,
            "Employee Count": emp.empCount,

            "Dept Overall Count": deptData.overallEmployeeCount,
            "Dept Present Count": deptData.totalEmployeePresentCount,
            "Dept Avg Login": deptData.avgLoginHourse,
          });
          return;
        }

        // ✅ Date-wise rows (single sheet)
        Object.values(dates).forEach((day) => {
          rows.push({
            Department: departmentName,
            "Employee ID": emp.empId,
            "Employee Name": emp.empName,
            Date: day.date,

            "In Punch Count": day.inPunchCount,
            "Out Punch Count": day.outPunchCount,
            "Total Hours": day.totalHrs,
            "Productive Hours": day.productiveHrs,
            "Break Hours": day.breakHrs,

            "Present Days": emp.empPresentDayCount,
            "Avg Login Hours": emp.empAvgLoginHourse,
            "Employee Count": emp.empCount,

            "Dept Overall Count": deptData.overallEmployeeCount,
            "Dept Present Count": deptData.totalEmployeePresentCount,
            "Dept Avg Login": deptData.avgLoginHourse,
          });
        });
      });
    });

    return rows;
  };

  const downloadExcel = () => {
    const excelData = prepareExcelData(rowDetails.data); // <-- your API response object

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Attendance Dept Wise Report",
    );

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Attendance_Date_Wise_Report.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <CardWithActions
      headerTitle="Attendance Employees Tracker"
      headerActions={[]}
    >
      {/* Filter Section */}
      <Box mb={2}>
        <Formik
          initialValues={{
            startDate: new Date(startDate),
            lastDate: new Date(endDate),
            empId: "",
            swipeDetails: "",
            department: "",
            workLocation: "",
          }}
          onSubmit={(values) => {
            setExpandedDepartments({});
            setSelectedMonth(values.startDate);
            setStartDate(formatToYMD(values.startDate));
            setEndDate(formatToYMD(values.lastDate));
            setEmployee(values.empId);
            setSwipe(values.swipeDetails);
            setWorkLocation(values.workLocation);
            setDepartment(values.department);
            handleSubmit();
          }}
        >
          {({ setFieldValue, values, resetForm }) => (
            <Form>
              <Grid
                container
                alignItems="center"
                spacing={2}
                // justifyContent="space-between"
              >
                <Grid item xs={12} sm={3} md={3} lg={3}>
                  <FormikDatePicker
                    type="date"
                    name="startDate"
                    label="Start Date"
                    views={["year", "month", "day"]}
                    placeholder="DD/MM/YYYY"
                    onChange={(value) => {
                      const date = formatToYMD(value);
                      setStartDate(date);
                      // console.log("Selected date:", value);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} md={3} lg={3}>
                  <FormikDatePicker
                    type="date"
                    name="lastDate"
                    label="End Date"
                    views={["year", "month", "day"]}
                    onChange={(value) => {
                      const date = formatToYMD(value);
                      setEndDate(date);
                    }}
                    placeholder="DD/MM/YYYY"
                  />
                </Grid>
                <Grid item xs={12} sm={3} md={3} lg={3}>
                  <FormikSelectInput
                    search={true}
                    name="empId"
                    options={fetchAllEmployees?.map((emp) => ({
                      value: emp.empId,
                      label: emp.employeeName,
                    }))}
                    label="Employee"
                    clear={true}
                    placeholder="Select Employee"
                    onChange={(value) => {
                      setEmployee(value.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} md={3} lg={3}>
                  <FormikSelectInput
                    search={true}
                    name="workLocation"
                    options={workLocationOptions?.map((emp) => ({
                      value: emp.value,
                      label: emp.name,
                    }))}
                    label="Work Location"
                    clear={true}
                    placeholder="Select Work Location"
                    onChange={(value) => {
                      setWorkLocation(value.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} md={3} lg={3}>
                  <FormikSelectInput
                    search={true}
                    name="department"
                    options={departmentOptions?.map((emp) => ({
                      value: emp.value,
                      label: emp.name,
                    }))}
                    label="Department"
                    clear={true}
                    placeholder="Select Department"
                    onChange={(value) => {
                      setDepartment(value.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} md={3} lg={3}>
                  <FormikSelectInput
                    search={true}
                    name="swipeDetails"
                    options={swipeMethodOptions?.map((emp) => ({
                      value: emp.value,
                      label: emp.name,
                    }))}
                    label="Swipe Details"
                    clear={true}
                    placeholder="Select Swipe Details"
                    onChange={(value) => {
                      setSwipe(value.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={9} sm={2} md={2} lg={2}>
                  <Box
                    sx={{
                      marginTop: "25px",
                    }}
                  >
                    <StyledButton
                      sx={{
                        p: (theme) => theme.spacing(1, 2),
                        // m: (theme) => theme.spacing(0, 1),
                        borderRadius: (theme) => theme.shape.s,
                        // height: 40,
                      }}
                      type="reset"
                      label="Reset"
                      variant="outlined"
                      color="error"
                      size="small"
                      onClick={() => {
                        (resetForm(),
                          setStartDate(
                            formatDate(
                              new Date(
                                today.getFullYear(),
                                today.getMonth(),
                                1,
                              ),
                            ),
                          ),
                          setEndDate(
                            formatDate(
                              new Date(
                                today.getFullYear(),
                                today.getMonth() + 1,
                                0,
                              ),
                            ),
                          ),
                          setEmployee(""),
                          setDepartment(""),
                          setWorkLocation(""),
                          setSwipe(""));
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4} md={4} lg={4}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "flex-end",
                      marginTop: "25px",
                    }}
                  >
                    {department &&
                      Object.keys(rowDetails?.data || {}).length > 0 && (
                        <Box sx={{ marginRight: 1 }}>
                          <SubmitButtonWithLoader
                            type="button"
                            label="Report Download"
                            submittingText="Downloading..."
                            variant="contained"
                            // color="primary"
                            // size="small"
                            onClick={() => downloadExcel()}
                            // loading={isDownloading}
                            startIcon={<DownloadIcon />}
                          >
                            Date Wise Excel
                          </SubmitButtonWithLoader>
                        </Box>
                      )}
                    {/* {Object.keys(rowDetails?.data || {}).length > 0 && ( */}
                    <SubmitButtonWithLoader
                      type="submit"
                      label="Report Download"
                      submittingText="Downloading..."
                      variant="contained"
                      // color="primary"
                      // size="small"
                      loading={isDownloading}
                      startIcon={<DownloadIcon />}
                    >
                      Download Tracker
                    </SubmitButtonWithLoader>
                    {/* )} */}
                  </Box>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Box>

      {/* Main Table */}
      <TableWrapper>
        <StyledTable>
          <TableHead>
            <TableRow>
              <TableCell>Department</TableCell>
              <TableCell>Employee Name</TableCell>
              <TableCell>Employee Code</TableCell>
              <TableCell>Employee Count</TableCell>
              <TableCell>Present Days</TableCell>
              <TableCell>Regularized Days</TableCell>
              <TableCell>Avg In</TableCell>
              <TableCell>Avg Out</TableCell>
              <TableCell>Avg Login Hrs</TableCell>
              <TableCell>Productive Hrs</TableCell>
              <TableCell>Break Hrs</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loadings ? (
              <TableRow>
                <TableCell colSpan={11} align="center">
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    py={3}
                  >
                    <CircularProgress size={24} sx={{ mr: 1 }} />
                    {/* <span>Loading data...</span> */}
                  </Box>
                </TableCell>
              </TableRow>
            ) : rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={11} align="center">
                  No data available
                </TableCell>
              </TableRow>
            ) : (
              rows.map((dept) => {
                const isDeptExpanded = !!expandedDepartments[dept.department];
                return (
                  <React.Fragment key={dept.department}>
                    <TableRow
                      sx={{ backgroundColor: "#f7f6f3", cursor: "pointer" }}
                      onClick={() =>
                        setExpandedDepartments((prev) => ({
                          ...prev,
                          [dept.department]: !prev[dept.department],
                        }))
                      }
                    >
                      <TableCell>
                        <IconButton size="small">
                          {isDeptExpanded ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )}
                        </IconButton>{" "}
                        <strong>{dept.department}</strong>
                      </TableCell>
                      <TableCell />
                      <TableCell />
                      <TableCell>{dept.overallEmployeeCount}</TableCell>
                      <TableCell>{dept.totalEmployeePresentCount}</TableCell>
                      <TableCell>
                        {dept.totalEmployeeRegularizationCount}
                      </TableCell>
                      <TableCell>{dept.avgInPunchCount}</TableCell>
                      <TableCell>{dept.avgOutPunchCount}</TableCell>
                      <TableCell>{dept.avgLoginHourse}</TableCell>
                      <TableCell>{dept.totalProductiveHousers}</TableCell>
                      <TableCell>{dept.totalBreakHousers}</TableCell>
                    </TableRow>
                    {isDeptExpanded &&
                      dept.members.map((emp, i) => {
                        const rowKey = `${dept.department}-${emp.empId || i}`;

                        return (
                          <React.Fragment key={rowKey}>
                            <TableRow>
                              <TableCell />
                              <TableCell>{emp.empName}</TableCell>
                              <TableCell>{emp.empId}</TableCell>
                              <TableCell>{emp.empCount}</TableCell>
                              <TableCell>{emp.empPresentDayCount}</TableCell>
                              <TableCell>{emp.empRegularizadCount}</TableCell>
                              <TableCell>{emp.empAvgInPunch}</TableCell>
                              <TableCell>{emp.empAvgOutPunch}</TableCell>
                              <TableCell>{emp.empAvgLoginHourse}</TableCell>
                              <TableCell>{emp.empProductiveHousers}</TableCell>
                              <TableCell>{emp.empBreakHourse}</TableCell>
                            </TableRow>
                          </React.Fragment>
                        );
                      })}
                  </React.Fragment>
                );
              })
            )}
          </TableBody>
        </StyledTable>
      </TableWrapper>
    </CardWithActions>
  );
};

export default AttendanceTracker;
